import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CallCenterDeviceProvider, CallCenterDevices, Spinner, } from "@madmedical/ui";
import { invariant, useDebounce } from "@madmedical/utils";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getConnectionStatusChoices, getLogisticsStatusChoices, getMetricTypeChoices, getOwnershipChoices, } from "@madmedical/medical";
import { useGetDeviceTypesQuery, useGetLogisticsDevicesQuery } from "./api";
import adaptDevice from "./adaptDevice";
import UpdateDeviceForm from "./UpdateDeviceForm";
import CreateDeviceForm from "./CreateDeviceForm";
var Modal;
(function (Modal) {
    Modal[Modal["Closed"] = 0] = "Closed";
    Modal[Modal["Create"] = 1] = "Create";
    Modal[Modal["Update"] = 2] = "Update";
})(Modal || (Modal = {}));
const Devices = () => {
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState({});
    const [search, setSearch] = useState();
    const debouncedSearch = useDebounce(search, 300, () => {
        setPage(1);
    });
    const { data: deviceTypes } = useGetDeviceTypesQuery();
    const { data, isLoading } = useGetLogisticsDevicesQuery(Object.assign(Object.assign({}, filter), { page }));
    const [modal, setModal] = useState(Modal.Closed);
    const [idForModal, setIdForModal] = useState();
    const filterChoices = useMemo(() => {
        var _a;
        return ({
            deviceTypes: (_a = deviceTypes === null || deviceTypes === void 0 ? void 0 : deviceTypes.map(({ id, name, manufacturer }) => {
                var _a;
                return ({
                    key: id,
                    text: `${manufacturer.forHumans} ${name}`,
                    isSelected: !!((_a = filter.deviceTypeIds) === null || _a === void 0 ? void 0 : _a.includes(id)),
                });
            })) !== null && _a !== void 0 ? _a : [],
            metricTypes: getMetricTypeChoices(filter.metricTypes),
            statuses: getLogisticsStatusChoices(filter.statuses),
            connectionStatuses: getConnectionStatusChoices(filter.connectionStatuses),
            ownerships: getOwnershipChoices(filter.ownerships),
        });
    }, [deviceTypes, filter]);
    const handleFilterChange = useCallback((key, selected) => {
        setPage(1);
        // TODO: Why does type inference fail me?
        const diff = key === "deviceTypes"
            ? { deviceTypeIds: selected }
            : key === "metricTypes"
                ? { metricTypes: selected }
                : key === "statuses"
                    ? { statuses: selected }
                    : key === "connectionStatuses"
                        ? { connectionStatuses: selected }
                        : key === "ownerships"
                            ? { ownerships: selected }
                            : {};
        setFilter((prevFilter) => (Object.assign(Object.assign({}, prevFilter), diff)));
    }, []);
    const handleSearchChange = (search) => {
        setSearch(search);
    };
    useEffect(() => {
        setFilter((prevFilter) => (Object.assign(Object.assign({}, prevFilter), { search: debouncedSearch })));
    }, [debouncedSearch]);
    const handleEndReached = useCallback(() => {
        if (!data) {
            return;
        }
        const { currentPage, pageCount } = data.pagination;
        if (currentPage >= pageCount) {
            return;
        }
        setPage(currentPage + 1);
    }, [data]);
    const handleAddPress = () => {
        setModal(Modal.Create);
    };
    const handleEditPress = (id) => {
        setIdForModal(id);
        setModal(Modal.Update);
    };
    const handleModalClose = () => {
        setIdForModal(undefined);
        setModal(Modal.Closed);
    };
    if (isLoading) {
        return _jsx(Spinner, {});
    }
    invariant(data, "No devices in sight");
    const { items: devices, pagination } = data;
    return (_jsxs(_Fragment, { children: [_jsx(CallCenterDeviceProvider, Object.assign({ value: {
                    devices: devices.map(adaptDevice),
                    pagination,
                    onSearchChange: handleSearchChange,
                    filterChoices,
                    onFilterChange: handleFilterChange,
                } }, { children: _jsx(CallCenterDevices, { onEndReached: handleEndReached, onAddPress: handleAddPress, onEditPress: handleEditPress }) })), _jsx(CreateDeviceForm, { open: modal === Modal.Create, onClose: handleModalClose }), idForModal && (_jsx(UpdateDeviceForm, { id: idForModal, open: modal === Modal.Update, onClose: handleModalClose }))] }));
};
export default Devices;
